import { Pipe, PipeTransform, inject } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
  name: 'linkify',
  standalone: false
})
export class LinkifyPipe implements PipeTransform {
  private domSanitizer = inject(DomSanitizer);


  transform(value: string, ...args: unknown[]): SafeHtml {
    return this.domSanitizer.bypassSecurityTrustHtml(this.stylize(value));
  }

  stylize(text: string): string {
    let stylizedText = '';
    if (!text) {
      return '';
    }
    if (typeof text === 'object') {
      text = text ? text[0] : '';
    }
    for (const word of text.split(/ |\n/)) {
      if (word.startsWith('https://t.co')) {
        stylizedText += `<a href="${word}" target="_blank">${word}</a> `;
      } else if (word.startsWith('@')) {
        const mention = word.replace(/<\/?b>|<\/?mark>|\.|:|,|;|@/g, '');
        stylizedText += `<a href="https://x.com/${mention}" target="_blank">${word}</a> `;
      } else if (word.startsWith('#')) {
        const hashtag = word.replace(/<\/?b>|<\/?mark>|\.|:|,|;|#/g, '');
        stylizedText += `<a href="https://x.com/hashtag/${hashtag}" target="_blank">${word}</a> `;
      } else {
        stylizedText += word + ' ';
      }
    }
    return stylizedText.trim();
  }

}
